export default __webpack_public_path__ + "static/Pressemeddelelse_Geno-ME Studiet_20201118-579ef5f85532525692289bf741d195eb.pdf";